import { render, staticRenderFns } from "./voiceManagement.vue?vue&type=template&id=5c8d984d&scoped=true"
import script from "./voiceManagement.vue?vue&type=script&lang=js"
export * from "./voiceManagement.vue?vue&type=script&lang=js"
import style0 from "./voiceManagement.vue?vue&type=style&index=0&id=5c8d984d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8d984d",
  null
  
)

export default component.exports